import { useRef } from "react"
import { useTranslation } from "react-i18next"

import { provideComponent } from "scrivito"
import { useMainRef } from "shared/context/MainRefContext"

import { BuildingReferenceFilter } from "widgets/building-reference-filter/BuildingReferenceFilter"
import { BuildingReferenceGrid } from "widgets/building-reference-grid/BuildingReferenceGrid"

import { BuildingReferenceOverviewWidget } from "./BuildingReferenceOverviewWidgetClass"
import { useBuildingReferenceOverviewWidgetController } from "./model/useBuildingReferenceOverviewWidgetController"
import "./styles/_building-reference-overview-widget.scss"

provideComponent(BuildingReferenceOverviewWidget, () => {
  const {
    filterState,
    hasFilter,
    defaultValues,
    productOptions,
    isLoadingProducts,
    buildingReferenceObjs,
    onChange
  } = useBuildingReferenceOverviewWidgetController()
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement | null>(null)
  const mainRef = useMainRef({ fallback: ref })

  const emptyMessage = hasFilter
    ? t("BuildingReference.NoResults")
    : t("BuildingReference.Empty")

  return (
    <div ref={ref} className="building-reference-overview-widget">
      <BuildingReferenceFilter
        defaultValues={defaultValues}
        productOptions={productOptions}
        isLoading={isLoadingProducts}
        onChange={onChange}
      />
      <BuildingReferenceGrid
        buildingReferenceObjs={buildingReferenceObjs}
        emptyMessage={emptyMessage}
        container={mainRef?.current}
        priorityProducts={filterState.products}
      />
    </div>
  )
})
